import Vue from 'vue'
import VueRouter from 'vue-router'
import Error from '../views/screen/404'
import Screen from '../views/screen/index'
import Details from '../views/screen/details'
import env from '@/config/env'

// 丰城
import FCLayout from '../views/fc-screen/layout'
import FCMain from '../views/fc-screen/main'
import FCCQIndex from '../views/fc-screen/index'
import FCNSHome from '../views/fc-screen/home'
import FCMap from '../views/fc-screen/map'
import FCStatistics from '../views/fc-screen/statistics'
import FCMoreAppointment from '../views/fc-screen/moreAppointment'

// 农机
import NJLayout from '../views/nj/layout'
// import NJCQIndex from '../views/nj/index'
import NJNSHome from '../views/nj/home'
import NJMap from '../views/nj/map'
import NJStatistics from '../views/nj/statistics'
import NJMoreAppointment from '../views/nj/moreAppointment'

Vue.use(VueRouter)

let routes = []

const currRouteType = window.location.pathname.split('/')[1]

if (!env.NJSCREENCONTENTS.includes(currRouteType)) {
    routes = [
        // 丰城大屏
        {
            path: '/fc-screen',
            name: 'fc-screen',
            component: FCLayout,
            redirect: {
                name: 'fc-main'
            },
            children: [
                {
                    path: 'fc-main',
                    name: 'fc-main',
                    meta: {
                        title: '丰城市大数据管理平台'
                    },
                    component: FCMain
                },
                {
                    path: 'cq-index',
                    name: 'cq-index',
                    meta: {
                        title: '丰城市农村产权交易大数据'
                    },
                    component: FCCQIndex
                },
                {
                    path: 'ns-index',
                    name: 'ns-index',
                    meta: {
                        title: '丰城市农事服务大数据'
                    },
                    component: FCNSHome
                },
                {
                    path: 'map',
                    name: 'map',
                    meta: {
                        title: '丰城市农机服务大数据'
                    },
                    component: FCMap
                },
                {
                    path: 'statistics',
                    name: 'statistics',
                    meta: {
                        title: '丰城市农机作业统计'
                    },
                    component: FCStatistics
                },
                {
                    path: 'moreAppointment',
                    name: 'moreAppointment',
                    meta: {
                        title: '丰城市农机预约列表'
                    },
                    component: FCMoreAppointment
                }
            ]
        },
        // 其他大屏
        {
            path: '/error',
            name: 'error',
            component: Error
        },
        {
            path: '/:id',
            name: 'screen',
            component: Screen
        },
        {
            path: '/zhongguo',
            name: 'zhongguo',
            component: Screen
        },
        {
            path: '/:id/haiken',
            name: 'haiken',
            component: Screen
        },
        {
            path: '/' + sessionStorage.getItem('locId') + '/details',
            name: 'details',
            component: Details
        },
        {
            path: '/zhongguo/details',
            name: 'details',
            component: Details
        }
    ]
} else {
    // 获取当前已开的大屏类型一级目录
    const currOpenType = env.NJSCREENCONTENTS.includes(currRouteType)
        ? env.NJSCREENCONTENTS.find((item) => item === currRouteType)
        : 'error'

    const currRouteName = window.location.pathname.split('/')[2]

    // 获取当前站点信息
    const currSite =
        env.NJSCREENSITE.findIndex((item) => item.key === currRouteName) !== -1
            ? env.NJSCREENSITE.find((item) => item.key === currRouteName)
            : { key: 'error', label: '', locId: -1 }

    sessionStorage.setItem(
        'currScreenType',
        JSON.stringify(Object.assign({ contents: currOpenType }, currSite))
    )

    routes = [
        // 新大屏（动态市区县方式）
        {
            path: `/${currOpenType}/${currSite.key}`,
            name: `${currOpenType}/${currSite.key}`,
            component: NJLayout,
            redirect: {
                name: currSite.key
            },
            children: [
                {
                    path: `/`,
                    name: currSite.key,
                    component: NJNSHome,
                    meta: {
                        isHeader: true,
                        isTags: true,
                        active: 'overview-data'
                    }
                },
                // {
                //     path: `/${currOpenType}/${currSite.key}/property-data`,
                //     name: currSite.key,
                //     component: NJCQIndex,
                //     meta: {
                //         isHeader: false,
                //         isTags: false
                //     }
                // },
                {
                    path: `/${currOpenType}/${currSite.key}/machinery-data`,
                    name: currSite.key,
                    component: NJMap,
                    meta: {
                        isHeader: true,
                        isTags: true,
                        active: 'machinery-data'
                    }
                },
                {
                    path: `/${currOpenType}/${currSite.key}/statistics-data`,
                    name: currSite.key,
                    component: NJStatistics,
                    meta: {
                        isHeader: true,
                        isTags: true,
                        active: 'statistics-data'
                    }
                },
                {
                    path: `/${currOpenType}/${currSite.key}/work-data`,
                    name: currSite.key,
                    component: NJMoreAppointment,
                    meta: {
                        isHeader: true,
                        isTags: false
                    }
                }
            ]
        },
        {
            path: '/error',
            name: 'error',
            component: Error
        }
    ]
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    // 不是 haiken 站点 to.name 等于 haiken 则进入 404
    if (!env.HAINLOCID.includes(to.params.id) && to.name === 'haiken') {
        next('/error')
    } else {
        next()
    }
    // 不是已开市区县农机大屏进入 404
    if (
        env.NJSCREENCONTENTS.includes(currRouteType) &&
        env.NJSCREENSITE.findIndex((item) => item.key === to.name) === -1
    ) {
        next('/error')
    } else {
        next()
    }
})

export default router
